import type React from 'react';

import type { RepresentasjonKontekstProps } from '../../types/entities';

import { iframeRef, iframeSrc } from './broker-utils';
import { RepresentasjonKontekst } from './representasjon-kontekst';

export const Broker: React.FC<RepresentasjonKontekstProps> = props => {
  return (
    <>
      {<RepresentasjonKontekst {...props} />}
      <iframe ref={iframeRef} src={iframeSrc} title="broker" hidden />
    </>
  );
};
